import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ReadMore from "../../../CommonUI/ReadMoreBtn/ReadMore";
import ZeroAccount from "../../../Pricing/Zeroaccount/zeroaccount";
// import Algotrading from "../../../../Images/tools/algo-trading/tradetronWelcome.png";
// import AlgoBulls from "../../../../Images/tools/algo-trading/AlgoBulls.png";
import Forextrading from "../../../../Images/tools/algo-trading/forex-trading.png";
import trading_14 from "../../../../Images/tools/algo-trading/algo-trading_14.png";
import trading_16 from "../../../../Images/tools/algo-trading/algo-trading_16.png";
import trading_18 from "../../../../Images/tools/algo-trading/algo-trading_18.png";
import smartOptionsAlgo from "../../../../Images/SmartOptions/smartOptions-algo.png";

import "./AlgoTrading.css";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import TrackApi from "../../../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function AlgoTrading() {
    window.scrollTo(0, 0);
    // let navigate = useNavigate();
    // const routeTradetron = () => {
    //     let path = "../AlgoTradeTron";
    //     navigate(path);
    // }
    const [cookies, setCookie] = useCookies(['LeadId']);

  const trackData=(id)=>{
    const payloadData={
      "RelatedProspectId":id,
      "ActivityNote": "Your Algo Trading Note",
      "mx_Custom_1": "Algo Trading",
      "mx_Custom_2": "Your  Algo Trading page Note",
      "mx_CustomObject_81":window.location.href
     }
     TrackApi(payloadData);
  }
  useEffect(()=>{
  
if(cookies && cookies.RelatedProspectId){
  trackData(cookies.RelatedProspectId);
}
    
  })
    return (
        <>
            <section className="algotradeher_section">
                <Container>
                    <Row className="align-items-center ">
                        <Col md={12} sm={12} xs={12}>
                            <div className="algotradeher_text">
                                <h1 className="p-2">Algo Trading</h1>
                                <p>Algorithmic trading, also known as Algo-trading, uses automated pre-programmed trading instructions to execute trades when a set of instructions is met. Algo executes a predefined set of instructions based on volume, quantity, time, pricing, or other metrics. Algo trading assists an investor/trader in overcoming his emotional quotient, removing trading biases and emotional backlogs, and putting trades on the terminal at lightning speed, reducing manual invention. Register with Moneysukh to experience best-in-class automatic trading with cutting-edge technology, as well as trade-in Algo’s to take advantage of minimal brokerage.</p>
                                {/* <span onClick={routeTradetron}>    
                                    <ReadMore name="Know" />
                                </span> */}
                            </div>
                        </Col>
                        {/* <Col md={5} sm={12} xs={12}  className="text-center pl-5">
                            <img src={Algotrading} alt="Tradetrontool-tool" className="img-fluid"></img>
                        </Col> */}

                    </Row>
                </Container>
            </section>

            <section className="algotools_section">
                <div className="algotools_main">
                    <Container>
                        <div className="page_heading"><h2><span>Our Algo World</span></h2></div>
                        <div className="algotools_grid">
                            <div className="row">
                            <div className="col-sm-6">
                                    <div className="algotools_grouppanel">
                                        <div className="algotools_panel text-center">
                                            <a href="/Trade-Radar"> <div className="algotools_img">
                                                <img src={trading_16} alt="Tradetrontool-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>Trade Radar</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="algotools_grouppanel SmartOption">
                                        <div className="algotools_panel text-center">
                                            <a href="/SmartOptions"> <div className="algotools_img">
                                                <img src={smartOptionsAlgo} alt="SmartOptions-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>Smart Options</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                
                               
                                {/* <div className="col-sm-4">
                                    <div className="algotools_grouppanel algobulls">
                                        <div className="algotools_panel text-center">
                                            <a href="/AlgoBulls"> <div className="algotools_img">
                                                <img src={AlgoBulls} alt="Tradetrontool-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>AlgoBulls</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div> */}

                            </div>
                        </div>

                        <div className="algotools_grid">
                            <div className="row">
                            <div className="col-sm-6">
                                    <div className="algotools_grouppanel sixback">
                                        <div className="algotools_panel text-center">
                                            <a href="/trading-view"> <div className="algotools_img">
                                                <img src={trading_14} alt="Tradetrontool-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>TradingView</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="algotools_grouppanel foxtrader">
                                        <div className="algotools_panel text-center">
                                            <a href="/FoxTrader"> <div className="algotools_img">
                                                <img src={Forextrading} alt="Tradetrontool-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>FoxTrader</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-sm-4">
                                    <div className="algotools_grouppanel sixback">
                                        <div className="algotools_panel text-center">
                                            <a href="/Quantman"> <div className="algotools_img">
                                                <img src={trading_18} alt="Tradetrontool-tool" className="img-fluid imghover"></img>
                                            </div>
                                                <h3>Quantman</h3>
                                            </a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
            <ZeroAccount />
        </>
    );
}
export default AlgoTrading;